import * as actions from "./actions"
import initialState from "./initialState"

export default (state = initialState, action) => {
  switch (action.type) {
    case actions.SET_USER:
      return {
        ...state,
        user: action.payload
      }
    default:
      return state
  }
}
